import React, { useEffect } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import './assets/scss/main.scss'
import Layout from './components/Layout'
import LoginPage from './pages/LoginPage'
import InvoicesPage from './pages/InvoicesPage'
import EditCategoriesPage from './pages/EditCategoriesPage'
import ProtectedRoute from './components/ProtectedRoute'
import useTheme from './hooks/useTheme'

function App() {
	const theme = useTheme()

	useEffect(() => {
		document.documentElement.setAttribute('data-bs-theme', theme)
	}, [theme])

	return (
		<BrowserRouter>
			<Routes>
				<Route path="/login" element={<LoginPage />} />
				<Route
					path="/"
					element={
						<ProtectedRoute>
							<Layout />
						</ProtectedRoute>
					}
				>
					<Route index element={<Navigate to="/invoices" replace />} />
					<Route path="invoices" element={<InvoicesPage />} />
					<Route path="categories" element={<EditCategoriesPage />} />
				</Route>
				<Route path="*" element={<Navigate to="/invoices" replace />} />
			</Routes>
		</BrowserRouter>
	)
}

export default App
